import { render, staticRenderFns } from "./TakeTongue.vue?vue&type=template&id=71ee46f9&scoped=true"
import script from "./TakeTongue.vue?vue&type=script&lang=ts"
export * from "./TakeTongue.vue?vue&type=script&lang=ts"
import style0 from "./TakeTongue.vue?vue&type=style&index=0&id=71ee46f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ee46f9",
  null
  
)

export default component.exports